import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { TenantsService } from '../../../../services/tenants.service';
import { PropertyType } from '../../../../model/property-type';

@Component({
  selector: 'app-tenant-property-types',
  templateUrl: './tenant-property-types.component.html',
  styleUrls: ['./tenant-property-types.component.scss']
})
export class TenantPropertyTypesComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public propertyTypes: PropertyType[];
  public totalPropertyTypes: number;
  public loadingPropertyTypes: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadPropertyTypes(this.first / this.rows, this.rows);
  }

  private loadPropertyTypes(offset: number, limit: number): void {
    this.loadingPropertyTypes = true;
    this.tenantsService.getTenantPropertyTypes(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.propertyTypes = response.propertyTypes.sort((a, b) => a.name > b.name ? 1 : -1);
        this.totalPropertyTypes = response.totalElements;
        this.loadingPropertyTypes = false;
      });
  }

  onPageChange(event): void {
    this.loadPropertyTypes(event.first / event.rows, event.rows);
  }

}
